// Rounds a number
export default function roundNumber(number: number): number {
	const m = Number((Math.abs(number) * 100).toPrecision(15));
	return (Math.round(m) / 100) * Math.sign(number);
}
